import { useEffect } from "react";
import { portalHref } from "../shell/routes";
import { openSimulator, requestFromQuery } from "../simulator/launch";

type Label = (key: string) => string;

/**
 * /portal/simulacion (Simulacion.razor): la ventana del simulador vive en el shell; esta página la abre con el objetivo de
 * la dirección (enlaces de Empleados IA y del portal actual) y queda como entrada con el botón para volver a abrirla.
 * El acceso lo decide el servidor (destino Empleados IA) antes de servir la página.
 */
export function SimulatorPage({ L, search }: { L: Label; search: string }) {
  useEffect(() => {
    openSimulator(requestFromQuery(search));
  }, [search]);
  return (
    <section className="simulator-entry">
      <h1>{L("SIM_GLOBAL_TITLE")}</h1>
      <p>{L("SIM_R1_SAFE_NOTICE")}</p>
      <div className="simulator-entry-actions">
        <button type="button" className="button" onClick={() => openSimulator(requestFromQuery(search))}>
          {L("SIM_R1_OPEN")}
        </button>
        <a className="button secondary" href={portalHref("/portal/empleados")}>
          {L("NAV_EMPLOYEES")}
        </a>
      </div>
    </section>
  );
}
